import React from 'react';
import Slider from './Slider';
import CardActualidad from '../Actualidad/Card';
import CardPublicaciones from '../Publicaciones/Card';
import CardSeminarios from '../CatedraOMC/Card';

const Home = (props) => (
  <div>
    <Slider />

    <section className="blog-wrapper blog02">
      <div className="container">

        <div className="row" style={{marginLeft: "-20px", marginRight: "-20px"}}>
          <div className="col-md-10 col-sm-10 col-sm-offset-1 col-md-offset-1">
            <div className="blog-six-content">
              <div className="blog-posts">

                {/*Actualidad*/}
                <div className="row">
                  <div className="row">
                    <div className="col-sm-10 section-header03">
                      <h2><span>Actualidad</span></h2>
                    </div>
                  </div>
                </div>
                <div className="row row-eq-height">
                  {props.actualidad.map((card, index) =>
                    <CardActualidad
                      image={card.fields.Imagen[0].thumbnails.large.url}
                      video={card.fields.Video}
                      date={card.fields.Fecha}
                      title={card.fields.Titulo}
                      id={card.id}
                      description={card.fields.Descripcion}
                      key={`card${index}`}
                    />
                  )}
                </div>

                {/*Publicaciones*/}
                <div className="row">
                  <div className="row">
                    <div className="col-sm-10 section-header03">
                      <h2><span>Nuestras </span>Publicaciones</h2>
                    </div>
                  </div>
                </div>
                <div className="row row-eq-height">
                  {props.publicaciones.map((card, index) =>
                    <CardPublicaciones
                      id={card.id}
                      image={card.fields.Imagen ? card.fields.Imagen[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      title={card.fields.Titulo}
                      autor={card.fields.Autor}
                      description={card.fields.Descripcion}
                      pdf={card.fields.PDF ? card.fields.PDF[0].url : []}
                      key={`card${index}`}
                    />
                  )}
                </div>

                {/*Seminarios y Cursos*/}
                <div className="row">
                  <div className="row">
                    <div className="col-sm-10 section-header03">
                      <h2><span>Seminarios</span></h2>
                    </div>
                  </div>
                </div>
                <div className="row row-eq-height" style={{}}>
                      {props.seminarios.map((card, index) =>
                  <CardSeminarios
                    mainState={card}
                    type={card.fields.Tipo[0].toLowerCase()}
                    fromTitle="Cátedra OMC"
                    fromLink="/catedra-omc"
                    key={`card${index}`}
                  />
                )}
                </div>

                {/*Agenda*/}
                <section className="all-course-wrapper events-style02">
                  <div className="row">
                    <div className="row">
                      <div className="col-sm-10 section-header03">
                        <h2><span>Nuestra</span> Agenda</h2>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="events-block">
                          <div className="row">

                            {props.agenda.length > 0 &&
                              props.agenda.map((evento, index) =>
                                <div className="col-sm-10" key={index}>
                                  <div className="event2-single">
                                    <div className="row">
                                      <div className="col-sm-2 event-date">
                                        <span>{evento.fields.Fecha.substring(8, evento.fields.Fecha.length)}</span>
                                        <span>{evento.fields.Fecha.substring(0, 7)}</span>
                                      </div>
                                      <div className="col-sm-3 event-thumb">
                                        <img src={evento.fields.Imagen[0].url} alt="" className="img-responsive" />
                                      </div>
                                      <div className="col-sm-7 event-info">
                                        <h3>{evento.fields.Titulo}</h3>
                                        <p className="event-td">
                                          <span><i className="fa fa-clock-o"></i>{evento.fields.Fecha}</span>
                                        </p>
                                        <p>{evento.fields.Descripcion}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            }

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
)

export default Home;
